// Lives in its own file (not inline in devicesFeature.ts) so route factories
// and screens can import these constants without a circular import back
// through devicesFeature.ts -> presentation/routes -> here.
const DEVICE_TYPES_LIST =
  "core.device_management.device_type_management_list";
const DEVICES_LIST = "core.device_management.device_management_list";
// Irregular segment: `sensor`, not `sensor_list` (see devicesFeature.ts's
// permissionCatalog comment) -- the Sensors Management screen itself lives
// in sensorAssignmentsFeature, which defines its own view constant; this one
// stays here since the segment belongs to the backend's device_management
// tree, and only grants create/view (no update/delete in the catalog).
const SENSOR = "core.device_management.sensor";

export const DEVICE_TYPES_VIEW = `${DEVICE_TYPES_LIST}.view`;
export const DEVICE_TYPES_CREATE = `${DEVICE_TYPES_LIST}.create`;
export const DEVICE_TYPES_UPDATE = `${DEVICE_TYPES_LIST}.update`;
export const DEVICE_TYPES_DELETE = `${DEVICE_TYPES_LIST}.delete`;

export const DEVICES_VIEW = `${DEVICES_LIST}.view`;
export const DEVICES_CREATE = `${DEVICES_LIST}.create`;
export const DEVICES_UPDATE = `${DEVICES_LIST}.update`;
export const DEVICES_DELETE = `${DEVICES_LIST}.delete`;

export const SENSOR_VIEW = `${SENSOR}.view`;
export const SENSOR_CREATE = `${SENSOR}.create`;
